// Generated by CoffeeScript 2.4.1
(function() {
  var Weaver, WeaverRelationNode;

  Weaver = require('./Weaver');

  WeaverRelationNode = class WeaverRelationNode extends Weaver.Node {
    constructor(nodeId, graphId, upsert) {
      if (nodeId == null) {
        throw new Error("Please always supply a relId when constructing WeaverRelationNode");
      }
      super(nodeId, graphId, upsert);
      this.fromNode = null; // is set elsewhere
      this.toNode = null; // is set elsewhere
      this.key = null;
    }

    static load(nodeId, params = {}) {
      var query;
      if (params.NodeClass == null) {
        params.NodeClass = WeaverRelationNode;
      }
      query = new Weaver.Query();
      query.withRelations();
      return query.get(nodeId, params);
    }

    from() {
      return this.fromNode;
    }

    to() {
      return this.toNode;
    }

    key() {
      return this.key;
    }

  };

  // Export
  module.exports = WeaverRelationNode;

}).call(this);
